{
  "title": "Hola de nuevo",
  "subtitle": {
    "email": "Iniciar sesión en tu cuenta",
    "password": "Ingresa tu contraseña",
    "magicLink": "Te enviaremos un enlace de acceso",
    "setupPassword": "Configura tu contraseña"
  },
  "buttons": {
    "loginMicrosoft": "Iniciar sesión con Microsoft",
    "loginMagicLink": "Iniciar con enlace mágico",
    "usePassword": "Usar contraseña en su lugar (solo para casos especiales)",
    "login": "Iniciar",
    "changeEmail": "Cambiar correo",
    "forgotPassword": "¿Olvidó su contraseña?",
    "setupPassword": "Crear contraseña",
    "sendLoginLink": "Enviar enlace acceso"
  },
  "fields": {
    "email": "Correo",
    "password": "Contraseña"
  },
  "errors": {
    "enterEmail": "Ingresa tu correo electrónico",
    "enterPassword": "Ingresa tu contraseña",
    "invalidCredentials": "Correo o contraseña incorrectos",
    "notWhitelisted": "La autenticación con contraseña no está disponible para tu cuenta. Por favor, usa Microsoft o Google para iniciar sesión.",
    "genericError": "Ocurrió un error. Intenta de nuevo."
  },
  "messages": {
    "passwordRestricted": "La autenticación con contraseña está restringida según la política de tu organización. La mayoría de los usuarios deben usar el inicio de sesión con Microsoft o Google de arriba.",
    "setupRequired": "Tu cuenta está aprobada para autenticación con contraseña. Configura una contraseña para continuar.",
    "noPasswordSet": "No hay contraseña configurada para esta cuenta. Puedes iniciar sesión usando un enlace mágico enviado a tu correo, o contactar a tu administrador para configurar la autenticación con contraseña.",
    "magicLinkTooltip": "El inicio de sesión con enlace mágico permite acceder de forma segura sin contraseña. Se enviará un enlace a la dirección de correo electrónico asociada a tu cuenta."
  },
  "magicLinkPage": {
    "title": "Iniciar sesión con enlace mágico",
    "description": "Ingresa tu correo electrónico para recibir un enlace de acceso.",
    "emailLabel": "Correo",
    "sendButton": "Enviar",
    "successTitle": "Revisa tu correo",
    "successMessage": "Se ha enviado un correo con el asunto <u>Iniciar sesión en AirPlx</u> a <u>{{email}}</u> con un enlace mágico. Haz clic en el enlace para iniciar sesión."
  }
}
